import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ContentView } from '../../content-view';
import { Markdown } from '../../markdown';
import { OperationSectionBody } from './OperationSectionBody';
import { OperationSectionHeading } from './OperationSectionHeading';
import { Badge } from '@criteria-labs/react';
export function OperationRequestBodySection({ operation }) {
    const { requestBody } = operation;
    if (!requestBody) {
        return null;
    }
    const { required, description, content = {} } = requestBody;
    return (_jsxs(_Fragment, { children: [_jsxs(OperationSectionHeading, { children: ["Request body", required && (_jsx(Badge, { color: "red", className: "ml-2", children: "required" }))] }), _jsxs(OperationSectionBody, { children: [_jsx("div", { className: "py-3", children: _jsx(Markdown, { content: description }) }), _jsx(ContentView, { content: content })] })] }));
}
